<div class="payment-result__state payment-result__state--not-found">
  <p>
    ⏱️ Lo sentimos, aún no hemos podido validar el pago con número de operación
    <strong>{{ message().operationNumber || 'no disponible' }}</strong>.
  </p>
  <p class="payment-result__closing">
    Por favor espera unos minutos más. De no obtener respuesta,
    repórtalo por el grupo de soporte.
  </p>
  @if (message().paymentRetryStatus === 'AVAILABLE' && !requestSent()) {
    <button
      type="button"
      class="manual-validation-trigger"
      (click)="requestManualValidation()"
    >Validar manualmente</button>
  }
</div>
